<template>
  <div class="home">
    <Welcome/>
    <Covid />

    <Intro/>
        <New2019 />
    <LiveRoom />

    <Services />
    
    <Equipment />
    
    
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from '@/components/Welcome.vue'
import Intro from '@/components/Intro.vue'
import New2019 from '@/components/New2019.vue'
import LiveRoom from '@/components/LiveRoom.vue'
import Equipment from '@/components/Equipment.vue'
import Services from '@/components/Services.vue'

import CcMap from '@/components/CcMap.vue'
import Covid from '@/components/Covid.vue'

export default {
  name: 'home', 
  components: {
    Welcome, 

    Intro,
        New2019,
    LiveRoom,
    Services,
    Covid,
    Equipment,

    CcMap
  }
}
</script>
